import { render } from "./permissionnew.vue?vue&type=template&id=a9234bea&scoped=true"
import script from "./permissionnew.vue?vue&type=script&lang=js"
export * from "./permissionnew.vue?vue&type=script&lang=js"

import "./permissionnew.vue?vue&type=style&index=0&id=a9234bea&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9234bea"]])

export default __exports__